(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["LR-collection-list"] && !Shopify.designMode) return;
  try {
    
const collectionswiper = new Swiper('.collection-swiper', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 20,
  centeredSlides: true,
  centeredSlidesBounds: true,
  navigation: {
    nextEl: '.collection-next',
    prevEl: '.collection-prev',
    clickable: true
  },
  breakpoints: {
    // When the viewport is <= 800px
    800: {
      slidesPerView: 3,
      spaceBetween: 30,
      centeredSlides: false
    }
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["LR-faq-page"] && !Shopify.designMode) return;
  try {
    
  // Every item starts closed ('+'). The icon (.active class) and the answer
  // (slideUp/Down) are toggled together on click, so they can't desync on load.
  $('.lr-faq-page-item').on('click', function() {
    var isActive = $(this).hasClass('active');
    if (isActive) {
      $(this).removeClass('active');
      $(this).find('.lr-faq-page-item__answer').slideUp(250);
    } else {
      $(this).addClass('active');
      $(this).find('.lr-faq-page-item__answer').slideDown(250);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["LR-faqs"] && !Shopify.designMode) return;
  try {
    
  $('.lr-faq-item').click(function(){
    $(this).children('.lr-faq-answer').slideToggle(300);
    $(this).children('.lr-plus-icon').find('.horizontal').fadeToggle(300);
    $(this).toggleClass('active');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["LR-home-banner"] && !Shopify.designMode) return;
  try {
    
  new Swiper('#lr-home-banner', {
    effect: 'fade',
    loop: true,
    navigation: {
      nextEl: '.home-banner-next',
      prevEl: '.home-banner-prev',
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["LR-story-feature"] && !Shopify.designMode) return;
  try {
    
(function () {
  // ── Lightbox (created once globally) ──────────────────────────────────────
  function getLightbox() {
    let lb = document.getElementById('lr-lightbox');
    if (!lb) {
      lb = document.createElement('div');
      lb.id = 'lr-lightbox';
      lb.className = 'lr-lightbox';
      lb.setAttribute('aria-hidden', 'true');
      lb.innerHTML =
        '<div class="lr-lightbox-bg"></div>' +
        '<div class="lr-lightbox-frame">' +
          '<img class="lr-lightbox-img" src="" alt="">' +
          '<button class="lr-lightbox-close" aria-label="Close">&#xd7;</button>' +
        '</div>';
      document.body.appendChild(lb);

      const close = () => {
        lb.classList.remove('active');
        lb.setAttribute('aria-hidden', 'true');
      };
      lb.querySelector('.lr-lightbox-bg').addEventListener('click', close);
      lb.querySelector('.lr-lightbox-close').addEventListener('click', close);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    }
    return lb;
  }

  function openLightbox(src, alt) {
    const lb = getLightbox();
    const img = lb.querySelector('.lr-lightbox-img');
    img.src = src;
    img.alt = alt || '';
    lb.classList.add('active');
    lb.removeAttribute('aria-hidden');
  }

  // ── Init each scrapbook container ─────────────────────────────────────────
  function initScrapbook(container) {
    const wraps = [...container.querySelectorAll('.lr-scrap-wrap')];
    const jiggle = container.dataset.jiggle === 'true';

    wraps.forEach((wrap) => {
      const img = wrap.querySelector('.lr-scrap-photo');

      // Click → lightbox
      wrap.addEventListener('click', () => {
        openLightbox(img.dataset.full || img.src, img.alt);
      });

      // Jiggle timer (staggered, skips if user is hovering)
      if (jiggle) {
        const scheduleJiggle = () => {
          const delay = 5000 + Math.random() * 5000;
          setTimeout(() => {
            if (!wrap.matches(':hover')) {
              wrap.classList.remove('lr-jiggling');
              // Force reflow so animation restarts cleanly
              void wrap.offsetWidth;
              wrap.classList.add('lr-jiggling');
              wrap.addEventListener('animationend', () => {
                wrap.classList.remove('lr-jiggling');
              }, { once: true });
            }
            scheduleJiggle();
          }, delay);
        };
        // Each photo starts at a different time
        const idx = [...container.querySelectorAll('.lr-scrap-wrap')].indexOf(wrap);
        setTimeout(scheduleJiggle, idx * 1400 + Math.random() * 2000);
      }
    });
  }

  // ── Init each photo carousel ───────────────────────────────────────────────
  function initStorySwiper(container) {
    const slideCount = container.querySelectorAll('.swiper-slide').length;
    let kbToggle = false; // alternates which Ken Burns motion (A/B) plays next

    function applyKenBurns(swiper) {
      const activeSlide = swiper.slides[swiper.activeIndex];
      const img = activeSlide && activeSlide.querySelector('img');
      if (!img) return;
      const nextClass = kbToggle ? 'lr-kb-b' : 'lr-kb-a';
      kbToggle = !kbToggle;
      img.classList.remove('lr-kb-a', 'lr-kb-b');
      // Force reflow so the animation restarts even if the same class
      // (e.g. after a full loop back around) gets reapplied.
      void img.offsetWidth;
      img.classList.add(nextClass);
    }

    new Swiper(container, {
      effect: 'fade',
      fadeEffect: { crossFade: true },
      speed: 1500,
      loop: slideCount > 1,
      autoplay: slideCount > 1 ? { delay: 7000, disableOnInteraction: false } : false,
      navigation: {
        nextEl: container.querySelector('.lr-story-next'),
        prevEl: container.querySelector('.lr-story-prev'),
      },
      on: {
        init: applyKenBurns,
        slideChangeTransitionStart: applyKenBurns,
      },
    });
  }

  // Run on DOMContentLoaded and re-run after Shopify editor section reloads
  function run() {
    document.querySelectorAll('.lr-scrapbook:not([data-scrap-init])').forEach((el) => {
      el.setAttribute('data-scrap-init', '1');
      initScrapbook(el);
    });
    document.querySelectorAll('.lr-story-photo.swiper:not([data-swiper-init])').forEach((el) => {
      el.setAttribute('data-swiper-init', '1');
      initStorySwiper(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Shopify theme editor live reload
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["LR-testimonials"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.testi-swiper', {
  effect: "fade",
  autoHeight: true,
  loop: true,
  //pagination: {
   // el: ".testimonial-pagination",
  //},
  navigation: {
    nextEl: '.testimonial-button-next',
    prevEl: '.testimonial-button-prev',
  },

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      if (!this.elements.button) return;
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }
    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }
    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }
    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }
    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) this.hidePanel();
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
